import { BorrowerFirstTimeBuyer, CoborrowerFirstTimeBuyer } from '../../cards/first-time-buyer';
import { Branch, Card } from '../../components/deck';

export default (borrowerKey, continuation) =>
  Branch(
    {
      borrower: Card(BorrowerFirstTimeBuyer),
      coborrower: Branch(
        {
          show: Card(CoborrowerFirstTimeBuyer)
        },
        ({ model }) => (model.getIn(['borrower', 'firstTimeBuyer']) ? 'show' : null)
      )
    },
    ({ model }) => {
      switch (model.getIn(['loan', 'scenario'])) {
        case 'Refi':
        case 'Refi-Qualify':
          return null;
        default:
          return borrowerKey;
      }
    },
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/first-time-buyer.js